import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import InteractiveToursPage from './InteractiveToursPage';

const msp = (state, ownProps) => ({});

const mdp = (dispatch) => ({});

export default withRouter(connect(msp, mdp)(InteractiveToursPage));
